module.exports = __webpack_public_path__ + "static/media/favourites.d9ad5355.svg";